module.exports = __webpack_public_path__ + "assets/img/title-75d9863c.png";